import { useModulePermission } from '@sdx/b2o-fe-tools';
import type { ModuleName } from '@sdx/b2o-fe-tools';

type UseIntegratedManagementPermissionProps = {
  accessToken: string | null;
  baseUrl: string;
  siteCode?: string;
};

type IntegratedManagementPermissionState = {
  isChecking: boolean;
  hasAccess: boolean | null;
};

const INTEGRATED_MANAGEMENT_MODULE: ModuleName = 'integrated-management';

export const useIntegratedManagementPermission = ({
  accessToken,
  baseUrl,
  siteCode,
}: UseIntegratedManagementPermissionProps): IntegratedManagementPermissionState => {
  const { permissions, isLoading, hasError, canExecute } = useModulePermission(
    INTEGRATED_MANAGEMENT_MODULE,
    {
      baseUrl,
      accessToken: accessToken ?? undefined,
      siteCode: siteCode ?? undefined,
    },
  );

  if (!canExecute || isLoading) {
    return { isChecking: true, hasAccess: null };
  }

  if (hasError || !permissions) {
    return { isChecking: false, hasAccess: false };
  }

  return { isChecking: false, hasAccess: permissions.canRead };
};
